import { EnumerationItem } from '@shared/interfaces/enumeration-item';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { HumanizePipe } from '@shared/pipes/humanize.pipe';

export function enumToSourceFiltered(enumName: object, enumMap?: EnumerationItem[]): IRadioButtonOption<number>[] {
  return Object.entries(enumName)
    .filter(([key, value]) => !isNaN(+value))
    .filter(([_, value]) => !enumMap || enumMap.some(item => item.enumerationValue === +value))
    .map(([key, value]) => {
      const mappedItem = enumMap?.find(item => item.enumerationValue === +value);
      return {
        label: mappedItem?.displayText || HumanizePipe.transform(key),
        value: +value,
      } as IRadioButtonOption<number>;
    });
}
